import axios from 'axios';
import { isExpired } from 'react-jwt';
import { API_URL } from '../config/Config'

const axiosInstance = axios.create({
    baseURL: API_URL
});

let tokenExpiration = null;
let isRefreshing = false;
let refreshSubscribers = [];
let lastRefreshTime = 0;

// Notify all subscribers when token is refreshed
const onRefreshed = (token) => {
    refreshSubscribers.forEach(callback => callback(token));
    refreshSubscribers = [];
};

// Add request to queue while refreshing
const addRefreshSubscriber = (callback) => {
    refreshSubscribers.push(callback);
};

async function refreshToken(config, logoutCallback) {
    // Check if token was refreshed in last 10 minutes
    const tenMinutes = 10 * 60 * 1000;
    if (Date.now() - lastRefreshTime < tenMinutes) {
        console.log("Token was recently refreshed, skipping...");
        return;
    }

    // If already refreshing, queue this request
    if (isRefreshing) {
        console.log("Token refresh already in progress, queuing request...");
        return new Promise((resolve) => {
            addRefreshSubscriber((token) => {
                if (config) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                resolve();
            });
        });
    }

    isRefreshing = true;

    try {
        const tokenResponse = await window?.expose_instance;

        if (tokenResponse.idToken) {
            const tokenExpired = isExpired(tokenResponse.idToken)

            //TOD somehow the token can be axpired.
            if (!tokenExpired) {
                localStorage.setItem("central-site-token", tokenResponse.idToken);
                lastRefreshTime = Date.now();
                
                if (config) {
                    config.headers.Authorization = `Bearer ${tokenResponse.idToken}`;
                }
                // Refresh token if within 15 minutes of expiry
                tokenExpiration = tokenResponse.expiresOn.getTime() - (15 * 60 * 1000);
                console.log("Token refreshed successfully. Expires at:", new Date(tokenResponse.expiresOn));
                
                // Notify all queued requests
                onRefreshed(tokenResponse.idToken);
            } else {
                logoutCallback();
            }
        } else {
            logoutCallback();
        }
    } catch (error) {
        console.error("Token error", error);
        logoutCallback();
    } finally {
        isRefreshing = false;
    }
}

// Export function for proactive token refresh
export async function refreshTokenProactively(logoutCallback) {
    try {
        await refreshToken(null, logoutCallback);
    } catch (error) {
        console.error("Proactive token refresh failed", error);
    }
}

export const setupAxiosInterceptors = (logoutCallback) => {
    axiosInstance.interceptors.request.use(
        async (config) => {

            try {
                if (!tokenExpiration || Date.now() >= tokenExpiration) {
                    console.log("Token expiration threshold reached, refreshing...");
                    await refreshToken(config, logoutCallback);
                } else {
                    // console.log("Using existing token...");

                    var token = localStorage.getItem("central-site-token");
                    const tokenExpired = isExpired(token)

                    if (!tokenExpired) {
                        config.headers.Authorization = `Bearer ${token}`;
                    } else {
                        console.log("Token expired, refreshing...");
                        await refreshToken(config, logoutCallback);
                    }
                }
            } catch (error) {
                console.error("Token error", error);
                logoutCallback();
            }

            return config;
        },
        (error) => Promise.reject(error)
    );
};

export default axiosInstance;
